import React from 'react'
import { Box } from "@mui/system"
import { Typography, useMediaQuery, useTheme } from "@mui/material"

const HomeHeader = () => {
    const muiTheme = useTheme()
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'))

    return(
        <Box>
            <Box sx={{
                display: "flex",
                alignItems: "self-end",
                backgroundImage: 'url("/background/login.webp")',
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "294px",
                width: "100%",
                zIndex: 0,
            }}>
                <Box>
                    <Typography variant={isMobile ? 'h2':'h1'} color="common.white" mt="auto" ml={3} mb={6}>
                        Bem-vindo a C2P
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}


export default HomeHeader